export const ConvertDataByType = (
  data: any,
  isTotalPrice: boolean,
  isPyeonPrice: boolean,
) => {
  const getPriceType = (isTotalPrice: boolean, isPyeonPrice: boolean) => {
    const priceMap = {
      'true,true': 'TP', // 총액, 평단가
      'true,false': 'TM', // 총액, m단가
      'false,true': 'PP', // 평단가
      'false,false': 'PM', // m단가
    };
    return priceMap[`${isTotalPrice},${isPyeonPrice}`];
  };

  const calculateInitialArea = (data: any) => {
    const area =
      data.category === 'I' || data.category == null
        ? data.land_area
        : (data.building_area ?? data.land_area);
    return {
      meterArea: area,
      pyeong: Number((area / 3.3058).toFixed(2)),
    };
  };

  const formatPriceAndArea = (
    priceType: string,
    data: any,
    initialArea: { meterArea: number; pyeong: number },
    clearType: string,
  ) => {
    const getAreaValue = (
      clearType: string,
      priceType: string,
      category: string,
      initialArea: { meterArea: number; pyeong: number },
    ): string => {
      const isDiscountOrMonthly = clearType === 'D' || clearType === 'M';
      const isPyeong = priceType.includes('P');

      if (isDiscountOrMonthly) {
        return category === 'I'
          ? isPyeong
            ? `토지 ${initialArea.pyeong}평`
            : `토지 ${initialArea.meterArea}㎡`
          : category == null
            ? isPyeong
              ? `면적 ${initialArea.pyeong}평`
              : `면적 ${initialArea.meterArea}㎡`
            : isPyeong
              ? `건물 ${initialArea.pyeong}평`
              : `건물 ${initialArea.meterArea}㎡`;
      }
      switch (priceType) {
        case 'TP':
          return category === 'I'
            ? `토지 ${initialArea.pyeong}평`
            : category == null
              ? `면적 ${initialArea.pyeong}평`
              : `건물 ${initialArea.pyeong}평`;
        case 'TM':
          return category === 'I'
            ? `토지 ${initialArea.meterArea}㎡`
            : category == null
              ? `면적 ${initialArea.meterArea}㎡`
              : `건물 ${initialArea.meterArea}㎡`;
        case 'PP':
          return '1평';
        case 'PM':
          return '1㎡';
        default:
          return '';
      }
    };

    const getPrice = (
      clearType: string,
      priceType: string,
      data: any,
      initialArea: { meterArea: number; pyeong: number },
    ): number => {
      const isDiscountOrMonthly = clearType === 'D' || clearType === 'M';

      if (isDiscountOrMonthly) {
        return data.price;
      }

      if (priceType.includes('P') && !priceType.includes('T')) {
        const divisor =
          priceType === 'PP' ? initialArea.pyeong : initialArea.meterArea;
        return Number((data.price / divisor).toFixed(2));
      }

      return data.price;
    };

    // 호출부
    const areaValue = getAreaValue(
      clearType,
      priceType,
      data.category,
      initialArea,
    );
    const price = getPrice(clearType, priceType, data, initialArea);

    return {
      ...data,
      area: `${areaValue}`,
      price,
    };
  };

  const initialArea = calculateInitialArea(data);
  const priceType = getPriceType(isTotalPrice, isPyeonPrice);
  const clearType = data?.type?.trim() ?? 'S';

  return formatPriceAndArea(priceType, data, initialArea, clearType);
};

/**총액,단가에 따라 가격,면적을 수정해주는 함수 */
export const getPriceByType = (
  data: any,
  isTotalPrice: boolean,
  isPyeonPrice: boolean,
) => {
  // const priceType = isTotalPrice ? 'total' : isPyeonPrice ? 'pyeong' : 'meter';

  // const clearType = data.type?.trim();
  // if (clearType === 'D' || clearType === 'M') {
  //   return data.prc;
  // } else {
  //   return priceType === 'total'
  //     ? data.prc
  //     : priceType === 'pyeong'
  //       ? data.prc_p
  //       : data.prc_m;
  // }
  const getPriceType = (isTotalPrice: boolean, isPyeonPrice: boolean) => {
    const priceMap = {
      'true,true': 'TP', // 총액, 평
      'true,false': 'TM', // 총액, m
      'false,true': 'PP', // 단가, 평
      'false,false': 'PM', // 단가, m
    };
    return priceMap[`${isTotalPrice},${isPyeonPrice}`];
  };

  const calculateInitialArea = (data: any) => {
    return {
      meterArea: data?.area?.toFixed(2) || 1,
      pyeong: data?.pyeong?.toFixed(2) || 1,
    };
  };
  const formatPriceAndArea = (
    priceType: string,
    data: any,
    initialArea: { meterArea: number; pyeong: number },
    clearType: string,
  ) => {
    const getAreaValue = (
      clearType: string,
      priceType: string,
      category: string,
      initialArea: { meterArea: number; pyeong: number },
    ): string => {
      const isDiscountOrMonthly = clearType === 'D' || clearType === 'M';
      const isPyeong = priceType.includes('P');

      if (isDiscountOrMonthly) {
        return category === 'I'
          ? isPyeong
            ? `${initialArea.pyeong}평`
            : `${initialArea.meterArea}㎡`
          : category == null
            ? isPyeong
              ? `${initialArea.pyeong}평`
              : `${initialArea.meterArea}㎡`
            : isPyeong
              ? `${initialArea.pyeong}평`
              : `${initialArea.meterArea}㎡`;
      }
      switch (priceType) {
        case 'TP':
          return `${initialArea.pyeong}평`;
        case 'TM':
          return `${initialArea.meterArea}㎡`;
        case 'PP':
          return '1평';
        case 'PM':
          return '1㎡';
        default:
          return '';
      }
    };

    const getPrice = (
      clearType: string,
      priceType: string,
      data: any,
      initialArea: { meterArea: number; pyeong: number },
    ): number => {
      const isDiscountOrMonthly = clearType === 'D' || clearType === 'M';

      if (isDiscountOrMonthly) {
        return data.prc;
      }

      if (priceType.includes('P') && !priceType.includes('T')) {
        const divisor =
          priceType === 'PP' ? initialArea.pyeong : initialArea.meterArea;
        return Number((data.prc / divisor).toFixed(2));
      } else {
        return Number(data.prc);
      }
    };

    // 호출부
    const areaValue = getAreaValue(
      clearType,
      priceType,
      data.category,
      initialArea,
    );
    const price = getPrice(clearType, priceType, data, initialArea);
    return {
      ...data,
      area: `${areaValue}`,
      price,
    };
  };
  const initialArea = calculateInitialArea(data);
  const priceType = getPriceType(isTotalPrice, isPyeonPrice);
  const clearType = data.type?.trim();
  return formatPriceAndArea(priceType, data, initialArea, clearType);
};

export const ReportFormatNumber = (
  item: number | string | null,
  percent?: boolean,
  showUnit: boolean = true,
) => {
  const num = Number(item);

  if (percent) {
    return num.toFixed(1) + (showUnit ? ' %' : '');
  } else if (!percent && num) {
    return num.toLocaleString() + (showUnit ? ' 원' : ''); // percent가 false이면 '원'을 붙임
  } else {
    return '-';
  }
};
